import styled from 'styled-components';

export const Container = styled.div`
  section{
    width: 70vh;
    @media only screen and (max-width: 768px) {
      width: 65vh;
    }
    @media only screen and (max-width: 720px) {
      width: 58vh;
    }
  }

  form {
    width: 100%;

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }

    input {
      height: 40px;
    }
  }
  }
`;
